// Professional SVG icons to replace emojis in the warehouse optimization app
import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

// Contact & Communication Icons
export const EmailIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="22,6 12,13 2,6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const PhoneIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 16.92V19.92C22 20.52 21.52 21 20.92 21C10.4 21 2 12.6 2 2.08C2 1.48 2.48 1 3.08 1H6.08C6.68 1 7.16 1.48 7.16 2.08C7.16 3.58 7.45 5.03 7.98 6.38C8.13 6.78 8.01 7.23 7.68 7.56L6.21 9.03C7.63 12.44 11.56 16.37 14.97 17.79L16.44 16.32C16.77 15.99 17.22 15.87 17.62 16.02C18.97 16.55 20.42 16.84 21.92 16.84C22.52 16.84 23 17.32 23 17.92V20.92H22Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const BuildingIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 21H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 21V7L13 2L21 7V21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 9V9.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 12V12.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 15V15.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 9V9.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 12V12.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 15V15.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Analytics & Data Icons
export const AnalyticsIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 3V21H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 9L13 14L9 10L3 16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 14V9H13" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ChartBarIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke={color} strokeWidth="2"/>
    <rect x="7" y="8" width="3" height="8" fill={color}/>
    <rect x="14" y="12" width="3" height="4" fill={color}/>
    <rect x="10.5" y="6" width="3" height="10" fill={color}/>
  </svg>
);

export const TrendUpIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="23,6 13.5,15.5 8.5,10.5 1,18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="17,6 23,6 23,12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Warehouse & Inventory Icons
export const WarehouseIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 22H22V10L12 2L2 10V22Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 22V12H18V22" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 18H14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 15H16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const PackageIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 8L12 13L3 8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 16L12 21L3 16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 8L12 3L21 8V16L12 21L3 16V8Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const BoxIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 16V8C21 6.9 20.1 6 19 6H5C3.9 6 3 6.9 3 8V16C3 17.1 3.9 18 5 18H19C20.1 18 21 17.1 21 16Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="3,12 21,12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 6V18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Status & Alert Icons
export const CheckCircleIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = '#10B981' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 11.08V12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C13.18 2 14.32 2.25 15.38 2.69" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="22,4 12,14.01 9,11.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const AlertTriangleIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = '#F59E0B' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.29 3.86L1.82 18C1.64 18.37 1.82 18.82 2.18 19C2.3 19.08 2.44 19.12 2.59 19.12H21.42C21.82 19.12 22.15 18.79 22.15 18.39C22.15 18.24 22.11 18.1 22.03 17.98L13.56 3.86C13.38 3.49 12.93 3.31 12.56 3.49C12.43 3.56 12.32 3.67 12.25 3.8L10.29 3.86Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="9" x2="12" y2="13" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="17" x2="12.01" y2="17" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const XCircleIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = '#EF4444' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
    <line x1="15" y1="9" x2="9" y2="15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="9" y1="9" x2="15" y2="15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Technology & AI Icons
export const CpuIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="16" height="16" rx="2" ry="2" stroke={color} strokeWidth="2"/>
    <rect x="9" y="9" width="6" height="6" stroke={color} strokeWidth="2"/>
    <line x1="9" y1="1" x2="9" y2="4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="15" y1="1" x2="15" y2="4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="9" y1="20" x2="9" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="15" y1="20" x2="15" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="20" y1="9" x2="23" y2="9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="20" y1="14" x2="23" y2="14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="1" y1="9" x2="4" y2="9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="1" y1="14" x2="4" y2="14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ZapIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const BrainIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C13.1 2 14 2.9 14 4C14 4.74 13.6 5.39 13 5.73V7C13 8.1 13.9 9 15 9C16.1 9 17 8.1 17 7V6C17 4.9 17.9 4 19 4C20.1 4 21 4.9 21 6V8C21 12.42 17.42 16 13 16H11C6.58 16 3 12.42 3 8V6C3 4.9 3.9 4 5 4C6.1 4 7 4.9 7 6V7C7 8.1 7.9 9 9 9C10.1 9 11 8.1 11 7V5.73C10.4 5.39 10 4.74 10 4C10 2.9 10.9 2 12 2Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 16V20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 18H16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const RefreshIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12C21 16.97 16.97 21 12 21C9.5 21 7.26 19.94 5.64 18.32" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 18L5.64 18.32L6 15.68" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CloudIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 10H16.74C16.24 6.67 13.39 4 10 4C6.15 4 3 7.15 3 11C3 11.34 3.04 11.67 3.09 12H2C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16H18C19.66 16 21 14.66 21 13C21 11.34 19.66 10 18 10Z" fill={color}/>
  </svg>
);

export const LockIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke={color} strokeWidth="2"/>
    <circle cx="12" cy="16" r="1" fill={color}/>
    <path d="M7 11V7C7 4.24 9.24 2 12 2C14.76 2 17 4.24 17 7V11" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Utility Icons
export const SettingsIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2"/>
    <path d="M19.4 15C19.2 15.29 19.2 15.71 19.4 16L20.4 17.5C20.6 17.79 20.6 18.21 20.4 18.5L18.6 21.5C18.4 21.79 18 21.93 17.7 21.8L16 21C15.71 21.18 15.29 21.18 15 21V22.5C15 22.78 14.78 23 14.5 23H10.5C10.22 23 10 22.78 10 22.5V21C9.71 21.18 9.29 21.18 9 21L7.3 21.8C7 21.93 6.6 21.79 6.4 21.5L4.6 18.5C4.4 18.21 4.4 17.79 4.6 17.5L5.6 16C5.8 15.71 5.8 15.29 5.6 15L4.6 13.5C4.4 13.21 4.4 12.79 4.6 12.5L6.4 9.5C6.6 9.21 7 9.07 7.3 9.2L9 10C9.29 9.82 9.71 9.82 10 10V8.5C10 8.22 10.22 8 10.5 8H14.5C14.78 8 15 8.22 15 8.5V10C15.29 9.82 15.71 9.82 16 10L17.7 9.2C18 9.07 18.4 9.21 18.6 9.5L20.4 12.5C20.6 12.79 20.6 13.21 20.4 13.5L19.4 15Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const LightBulbIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 21H15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 17V21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 3C8.69 3 6 5.69 6 9C6 10.57 6.63 12 7.69 13.06L9 14.37V17H15V14.37L16.31 13.06C17.37 12 18 10.57 18 9C18 5.69 15.31 3 12 3Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const SearchIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="8" stroke={color} strokeWidth="2"/>
    <path d="m21 21-4.35-4.35" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const TargetIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
    <circle cx="12" cy="12" r="6" stroke={color} strokeWidth="2"/>
    <circle cx="12" cy="12" r="2" stroke={color} strokeWidth="2"/>
  </svg>
);

export const DashboardIcon: React.FC<IconProps> = ({ width = 24, height = 24, className = '', color = 'currentColor' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="7" height="9" rx="1" stroke={color} strokeWidth="2"/>
    <rect x="14" y="3" width="7" height="5" rx="1" stroke={color} strokeWidth="2"/>
    <rect x="14" y="12" width="7" height="9" rx="1" stroke={color} strokeWidth="2"/>
    <rect x="3" y="16" width="7" height="5" rx="1" stroke={color} strokeWidth="2"/>
  </svg>
);

// Export all icons as a collection
export const Icons = {
  Email: EmailIcon,
  Phone: PhoneIcon,
  Building: BuildingIcon,
  Analytics: AnalyticsIcon,
  ChartBar: ChartBarIcon,
  TrendUp: TrendUpIcon,
  Warehouse: WarehouseIcon,
  Package: PackageIcon,
  Box: BoxIcon,
  CheckCircle: CheckCircleIcon,
  AlertTriangle: AlertTriangleIcon,
  XCircle: XCircleIcon,
  Cpu: CpuIcon,
  Zap: ZapIcon,
  Brain: BrainIcon,
  Settings: SettingsIcon,
  LightBulb: LightBulbIcon,
  Search: SearchIcon,
  Target: TargetIcon,
  Refresh: RefreshIcon,
  Cloud: CloudIcon,
  Lock: LockIcon,
  Dashboard: DashboardIcon,
};

export default Icons;